import * as i0 from '@angular/core';
import { EventEmitter, Component, NgModule, Injectable } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import * as i2 from '@anb/ng-maps';
import { ANBDraw, ANBLayer } from '@anb/ng-maps';
import * as jsts from 'jsts';
import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';
import { Style as Style$1, Fill as Fill$1, Stroke as Stroke$1, Circle } from 'ol/style';
import { Overlay } from 'ol';
import { cloneDeep } from 'lodash-es';
import { forkJoin, Observable } from 'rxjs';
import { unByKey } from 'ol/Observable';
import * as i1$1 from '@anb/ng-kadaster';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import { bbox } from 'ol/loadingstrategy';
import { TileWMS } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import * as i1$2 from '@angular/common/http';
import * as i3 from '@anb/ng-configuratie';
import WFS from 'ol/format/WFS';
import { intersects } from 'ol/format/filter';
import { map } from 'rxjs/operators';

/* eslint-disable @typescript-eslint/no-explicit-any */
class MapPopoverComponent {
    constructor() {
        this.onDeleteClick = new EventEmitter();
        this.customActions = [];
        this.onCloseClick = new EventEmitter();
        this.onCustomActionClick = new EventEmitter();
    }
    onCustomClick(action) {
        if (!action) {
            return;
        }
        this.onCustomActionClick.emit(action);
    }
    onDeletePolygoonClick(event) {
        if (!event) {
            return;
        }
        this.onDeleteClick.emit(event);
    }
    onCloseMapPopoverClick(event) {
        if (!event) {
            return;
        }
        this.onCloseClick.emit(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapPopoverComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.7", type: MapPopoverComponent, selector: "anb-gl-map-popover", ngImport: i0, template: "<div class=\"vl-popover--align-left\">\n  <div class=\"vl-popover__content\" style=\"display: block;\">\n    <ul class=\"vl-popover__link-list\">\n      <li class=\"vl-popover__link-list__item\" *ngFor=\"let customAction of customActions\">\n        <a href=\"javascript:void(0)\" class=\"vl-link vl-link--block\" (click)=\"onCustomClick(customAction)\">\n          <i [className]=\"customAction.class\" aria-hidden=\"true\"></i>\n          {{customAction.title}}\n        </a>\n      </li>\n    </ul>\n    <ul class=\"vl-popover__link-list\">\n      <li class=\"vl-popover__link-list__item\">\n        <a href=\"javascript:void(0)\" class=\"vl-link vl-link--block\" (click)=\"onDeletePolygoonClick($event)\">\n          <i class=\"vl-link__icon vl-link__icon--before vl-vi vl-vi-bin\" aria-hidden=\"true\"></i>\n          verwijder\n        </a>\n      </li>\n    </ul>\n    <button class=\"vl-popover__close-btn vl-vi vl-vi-cross\" tabindex=\"0\" (click)=\"onCloseMapPopoverClick($event)\">\n      <span class=\"vl-u-visually-hidden\">Close popover</span>\n    </button>\n  </div>\n</div>\n", styles: ["::ng-deep .ol-overlay-container .vl-popover__content:before{content:none}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-gl-map-popover', template: "<div class=\"vl-popover--align-left\">\n  <div class=\"vl-popover__content\" style=\"display: block;\">\n    <ul class=\"vl-popover__link-list\">\n      <li class=\"vl-popover__link-list__item\" *ngFor=\"let customAction of customActions\">\n        <a href=\"javascript:void(0)\" class=\"vl-link vl-link--block\" (click)=\"onCustomClick(customAction)\">\n          <i [className]=\"customAction.class\" aria-hidden=\"true\"></i>\n          {{customAction.title}}\n        </a>\n      </li>\n    </ul>\n    <ul class=\"vl-popover__link-list\">\n      <li class=\"vl-popover__link-list__item\">\n        <a href=\"javascript:void(0)\" class=\"vl-link vl-link--block\" (click)=\"onDeletePolygoonClick($event)\">\n          <i class=\"vl-link__icon vl-link__icon--before vl-vi vl-vi-bin\" aria-hidden=\"true\"></i>\n          verwijder\n        </a>\n      </li>\n    </ul>\n    <button class=\"vl-popover__close-btn vl-vi vl-vi-cross\" tabindex=\"0\" (click)=\"onCloseMapPopoverClick($event)\">\n      <span class=\"vl-u-visually-hidden\">Close popover</span>\n    </button>\n  </div>\n</div>\n", styles: ["::ng-deep .ol-overlay-container .vl-popover__content:before{content:none}\n"] }]
        }] });

class MapUtilModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.7", ngImport: i0, type: MapUtilModule, declarations: [MapPopoverComponent], imports: [CommonModule], exports: [MapPopoverComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MapPopoverComponent],
                    imports: [CommonModule],
                    exports: [MapPopoverComponent]
                }]
        }] });

class ClipInteractionConfiguration {
}

class ClipInteractionResult {
}

const DEFAULT_COLORS = {
    fill: [255, 255, 255, 0],
    white: [255, 255, 255, 1],
    blue: [0, 153, 255, 1],
    width: 3,
};
const DRAW_POLYGON_COLORS = {
    originalDrawEndStyle: new Style({ fill: new Fill({ color: 'rgba(255,255,102, 0.75)' }) }),
    originalSelectedStyle: [
        new Style({
            stroke: new Stroke({
                color: DEFAULT_COLORS.white,
                width: DEFAULT_COLORS.width + 2,
            }),
        }),
        new Style({
            stroke: new Stroke({
                color: DEFAULT_COLORS.blue,
                width: DEFAULT_COLORS.width,
            }),
            fill: new Fill({ color: 'rgba(255,255,102, 0.75)' }),
        }),
    ],
};
const SELECT_PARCEL_COLORS = {
    originalStyle: new Style({ fill: new Fill({ color: 'rgba(255,255,102, 0.75)' }) }),
};

var GrbTypeEnum;
(function (GrbTypeEnum) {
    GrbTypeEnum["grb_bsk_grijs"] = "grb_bsk_grijs";
    GrbTypeEnum["grb_bsk"] = "grb_bsk";
    GrbTypeEnum["ortho"] = "omwrgbmrvl";
    GrbTypeEnum["ortho_middel_winter_2015"] = "omwrgb15vl";
    GrbTypeEnum["ortho_middel_zomer_2015"] = "omzrgb15vl";
    GrbTypeEnum["ortho_middel_winter_2008_2011"] = "omwrgb08_11vl";
    GrbTypeEnum["ortho_middel_zomer_2009"] = "omzrgb09vl";
    GrbTypeEnum["ortho_middel_winter_2005_2007"] = "omwrgb05_07vl";
    GrbTypeEnum["ortho_middel_winter_2000_2003"] = "omwrgb00_03vl";
    GrbTypeEnum["ortho_klein_zomer_1979_1990"] = "okzrgb79_90vl";
})(GrbTypeEnum || (GrbTypeEnum = {}));

var ParcelSelectionTypeEnum;
(function (ParcelSelectionTypeEnum) {
    ParcelSelectionTypeEnum[ParcelSelectionTypeEnum["POINT"] = 0] = "POINT";
    ParcelSelectionTypeEnum[ParcelSelectionTypeEnum["LINE"] = 1] = "LINE";
    ParcelSelectionTypeEnum[ParcelSelectionTypeEnum["POLYGON"] = 2] = "POLYGON";
})(ParcelSelectionTypeEnum || (ParcelSelectionTypeEnum = {}));

class MultipleParcelInteractionConfiguration {
}

class Municipality {
}

let Parcel$1 = class Parcel {
};

class ParcelInteractionConfiguration {
}

class Polygon {
}

class PolygonInteractionConfiguration {
}

class DomService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    appendComponentToBody(component) {
        // 1. Create a component reference from the component
        const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);
        // 2. Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(componentRef.hostView);
        // 3. Get DOM element from component
        const domElem = this.getHTMLElement(componentRef);
        // 4. Append DOM element to the body
        document.body.appendChild(domElem);
        return componentRef;
    }
    getHTMLElement(componentRef) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return componentRef.hostView.rootNodes[0];
    }
    removeComponentFromBody(componentRef) {
        // remove it from the component tree and from the DOM
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: DomService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: DomService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: DomService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }]; } });

class StyleHelper {
    static getDefaultStyle(feature) {
        const styles = [];
        styles['Polygon'] = [
            new Style$1({
                fill: new Fill$1({
                    color: DEFAULT_COLORS.fill,
                }),
            }),
        ];
        styles['MultiPolygon'] = styles['Polygon'];
        styles['LineString'] = [
            new Style$1({
                stroke: new Stroke$1({
                    color: DEFAULT_COLORS.white,
                    width: DEFAULT_COLORS.width + 2,
                }),
            }),
            new Style$1({
                stroke: new Stroke$1({
                    color: DEFAULT_COLORS.blue,
                    width: DEFAULT_COLORS.width,
                }),
            }),
        ];
        styles['MultiLineString'] = styles['LineString'];
        styles['Point'] = [
            new Style$1({
                image: new Circle({
                    radius: DEFAULT_COLORS.width * 2,
                    fill: new Fill$1({
                        color: DEFAULT_COLORS.blue,
                    }),
                    stroke: new Stroke$1({
                        color: DEFAULT_COLORS.white,
                        width: DEFAULT_COLORS.width / 2,
                    }),
                }),
                zIndex: Infinity,
            }),
        ];
        styles['MultiPoint'] = styles['Point'];
        styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
        return styles[feature.getGeometry().getType()];
    }
}

class ClipPolygonHelper {
    constructor(vectorService, domService, olMap, polygonVectorLayer, config = null) {
        this.wkt = new WKT();
        this.reader = new jsts.io.WKTReader();
        this.writer = new jsts.io.WKTWriter();
        // Styles
        this.originalDrawEndStyle = DRAW_POLYGON_COLORS.originalDrawEndStyle;
        this.drawStartStyle = StyleHelper.getDefaultStyle;
        this.drawEndStyle = this.originalDrawEndStyle;
        this.vectorService = vectorService;
        this.domService = domService;
        this.olMap = olMap;
        this.polygonVectorLayer = polygonVectorLayer;
        this.config = config;
        this.initStyles();
    }
    /**
     * Start draw of a polygon on a layer
     *
     * @memberof DrawPolygonHelper
     */
    startClipPolygonInteraction() {
        // Init the draw interaction on the map
        this.initClipPolygonInteraction();
        this.olMap.addInteraction(this.drawPolygon);
    }
    /**
     * End draw of a polygon on a layer
     *
     * @memberof DrawPolygonHelper
     */
    stopClipPolygonInteraction() {
        this.olMap.removeInteraction(this.drawPolygon);
    }
    /**
     * Init styles of the config
     *
     * @memberof DrawPolygonHelper
     */
    initStyles() {
        if (this.config && this.config.drawStartStyle) {
            this.drawStartStyle = this.config.drawStartStyle;
        }
        if (this.config && this.config.drawEndStyle) {
            this.drawEndStyle = this.config.drawEndStyle;
        }
    }
    /**
     * Init draw polygon interaction on the map
     *
     * @memberof DrawPolygonHelper
     */
    initClipPolygonInteraction() {
        // Create the draw interaction
        this.drawPolygon = new ANBDraw({
            type: 'Polygon',
            style: this.drawStartStyle,
        });
        // Subscripte onDrawStart
        this.drawPolygon.onDrawStart.subscribe((c) => {
            if (c == null) {
                return;
            }
        });
        // Subscripte onDrawEnd
        this.drawPolygon.onDrawEnd.subscribe((c) => {
            if (c == null) {
                return;
            }
            // Set feature ID
            const uniqueId = Date.now() + Math.random();
            c.feature.setId(uniqueId.toString());
            // Create a polygon object for the event trigger
            const polygon = this.getPolygon(c.feature);
            const [deleted, updated] = this.clipOnPolygonVectorLayer(polygon);
            // Trigger the onAdd event
            if (this.config.onClip) {
                this.config.onClip.next({
                    clipPolygon: polygon,
                    deletedPolygons: this.getPolygons(deleted),
                    updatedPolygons: this.getPolygons(updated),
                });
            }
        });
    }
    /**
     * Gets polygons of feature list
     * @param features
     * @returns polygons
     */
    getPolygons(features) {
        if (features) {
            return features.map((feature) => this.getPolygon(feature));
        }
    }
    /**
     * Gets a polygon of a feature
     * @param feature
     * @returns polygon
     */
    getPolygon(feature) {
        const geoJsonFeature = new GeoJSON().writeFeature(feature);
        const geoJson = Object.assign({}, JSON.parse(geoJsonFeature));
        const polygon = {
            feature: feature,
            geoJson: geoJson,
        };
        return polygon;
    }
    /**
     * Clips on the polygon vector layer
     * @param polygon
     */
    clipOnPolygonVectorLayer(polygon) {
        const polygonFeatures = this.polygonVectorLayer.getSource().getFeatures();
        if (polygonFeatures) {
            const deletedPolygonFeatures = [];
            const updatedPolygonFeatures = [];
            polygonFeatures.forEach((polygonFeature) => {
                const polygonJsts = this.reader.read(new WKT().writeGeometry(polygonFeature.getGeometry()));
                const removeJsts = this.reader.read(new WKT().writeGeometry(polygon.feature.getGeometry()));
                const intersects = polygonJsts.intersects(removeJsts);
                if (intersects) {
                    const difference = polygonJsts.difference(removeJsts);
                    if (difference.getArea() !== 0) {
                        const differenceWKT = this.writer.write(difference);
                        const diffFeature = new WKT().readFeature(differenceWKT);
                        const newGeometry = diffFeature.getGeometry();
                        diffFeature.setProperties(polygonFeature.getProperties());
                        diffFeature.setId(polygonFeature.getId().toString());
                        diffFeature.setGeometry(newGeometry);
                        diffFeature.setStyle(this.drawEndStyle);
                        this.polygonVectorLayer.getSource().removeFeature(polygonFeature);
                        this.polygonVectorLayer.getSource().addFeature(diffFeature);
                        updatedPolygonFeatures.push(diffFeature);
                    }
                    else {
                        this.polygonVectorLayer.getSource().removeFeature(polygonFeature);
                        deletedPolygonFeatures.push(polygonFeature);
                    }
                }
                else {
                    return;
                }
            });
            return [deletedPolygonFeatures, updatedPolygonFeatures];
        }
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
class DrawPolygonHelper {
    constructor(vectorService, domService, olMap, layer, config = null) {
        this.isDrawStarted = false;
        this.isDrawCanceled = false;
        this.showDeleteButton = true;
        // Styles
        this.originalDrawEndStyle = DRAW_POLYGON_COLORS.originalDrawEndStyle;
        this.originalSelectedStyle = DRAW_POLYGON_COLORS.originalSelectedStyle;
        this.drawStartStyle = StyleHelper.getDefaultStyle;
        this.drawEndStyle = this.originalDrawEndStyle;
        this.selectedStyle = this.originalSelectedStyle;
        this.vectorService = vectorService;
        this.domService = domService;
        this.olMap = olMap;
        this.layer = layer;
        this.config = config;
        if (this.config.showDeleteButton !== null && this.config.showDeleteButton !== undefined) {
            this.showDeleteButton = this.config.showDeleteButton;
        }
        this.initStyles();
    }
    /**
     * Start draw of a polygon on a layer
     *
     * @memberof DrawPolygonHelper
     */
    startDrawPolygonInteraction() {
        // Create an instance of the Map Popover Component
        const mapPopoverComponent = this.domService.appendComponentToBody(MapPopoverComponent);
        // Set the custom actions on the Map Popover Component
        mapPopoverComponent.instance.customActions = this.config.customActions;
        // Subscribe on the close event of the Popover
        mapPopoverComponent.instance.onCloseClick.subscribe(() => {
            this.resetSelectedFeature();
        });
        // Subscribe on the delete event of the Popover
        mapPopoverComponent.instance.onDeleteClick.subscribe(() => {
            this.layer.getSource().removeFeature(this.selectedFeature);
            const polygon = {
                feature: this.selectedFeature,
                geoJson: null,
            };
            if (this.config.onDelete) {
                this.config.onDelete.next(polygon);
            }
            this.resetSelectedFeature();
        });
        if (mapPopoverComponent?.instance?.customActions?.length > 0) {
            mapPopoverComponent.instance.onCustomActionClick.subscribe((action) => {
                const polygon = {
                    feature: this.selectedFeature,
                    geoJson: null,
                };
                action.payload = polygon;
                this.config.onCustomAction.next(action);
                this.resetSelectedFeature();
            });
        }
        // Get the HTML Element of the Popover and hide the element
        const mapPopover = this.domService.getHTMLElement(mapPopoverComponent);
        this.mapPopover = mapPopover;
        this.hideMapPopover();
        // Init the draw interaction on the map
        this.initDrawPolygonInteraction();
        this.olMap.addInteraction(this.drawPolygon);
        const source = this.layer.getSource();
        // Subscribe on the click event on the map
        this.clickSubscription = this.olMap.map.on('click', (clickResult) => {
            if (!clickResult || !clickResult.coordinate || !this.showDeleteButton) {
                return;
            }
            this.resetSelectedFeature();
            const features = source.getFeaturesAtCoordinate([clickResult.coordinate[0], clickResult.coordinate[1]]);
            if (this.isDrawStarted) {
                // When clicked on an existing polygon
                if (features.length > 0) {
                    // Show popover menu
                    const popup = new Overlay({
                        element: mapPopover,
                    });
                    popup.setPosition(clickResult.coordinate);
                    this.olMap.map.addOverlay(popup);
                    this.showMapPopover();
                    this.selectedFeature = features[0];
                    // Set the style of the selected feature
                    this.selectedFeature.setStyle(this.selectedStyle);
                    this.isDrawCanceled = true;
                    this.drawPolygon.removeLastPoint();
                    this.drawPolygon.finishDrawing();
                }
                else {
                    this.isDrawCanceled = false;
                }
                this.isDrawStarted = false;
            }
            if (!this.selectedFeature) {
                this.resetSelectedFeature();
            }
        });
    }
    /**
     * End draw of a polygon on a layer
     *
     * @memberof DrawPolygonHelper
     */
    stopDrawPolygonInteraction() {
        this.olMap.removeInteraction(this.drawPolygon);
        this.isDrawStarted = false;
        this.resetSelectedFeature();
    }
    /**
     * Init styles of the config
     *
     * @memberof DrawPolygonHelper
     */
    initStyles() {
        if (this.config && this.config.drawStartStyle) {
            this.drawStartStyle = this.config.drawStartStyle;
        }
        if (this.config && this.config.drawEndStyle) {
            this.drawEndStyle = this.config.drawEndStyle;
        }
        if (this.config && this.config.selectedStyle) {
            this.selectedStyle = this.config.selectedStyle;
        }
    }
    /**
     * Init draw polygon interaction on the map
     *
     * @memberof DrawPolygonHelper
     */
    initDrawPolygonInteraction() {
        // Create the draw interaction
        this.drawPolygon = new ANBDraw({
            source: this.layer.getSource(),
            type: 'Polygon',
            style: this.drawStartStyle,
        });
        // Subscripte onDrawStart
        this.drawPolygon.onDrawStart.subscribe((c) => {
            if (c == null) {
                return;
            }
            this.isDrawStarted = true;
            // Reset the selected feature on draw start
            this.resetSelectedFeature();
        });
        // Subscripte onDrawEnd
        this.drawPolygon.onDrawEnd.subscribe((c) => {
            if (c == null) {
                return;
            }
            if (this.isDrawCanceled) {
                this.isDrawCanceled = false;
            }
            else {
                c.feature.setStyle(this.drawEndStyle);
                // Set feature ID
                const uniqueId = Date.now() + Math.random();
                c.feature.setId(uniqueId.toString());
                // Create a polygon object for the event trigger
                const feature = new GeoJSON().writeFeature(c.feature);
                const geoJson = Object.assign({}, JSON.parse(feature));
                const polygon = {
                    feature: c.feature,
                    geoJson: geoJson,
                };
                // Trigger the onAdd event
                if (this.config.onAdd) {
                    this.config.onAdd.next(polygon);
                }
            }
        });
    }
    /**
     * Reset the current selected feature on the map
     *
     * @memberof DrawPolygonHelper
     */
    resetSelectedFeature() {
        // Reset style
        let drawEndStyle = this.drawEndStyle;
        if (this.config && this.config.drawEndStyle) {
            drawEndStyle = this.config.drawEndStyle;
        }
        if (this.selectedFeature) {
            this.selectedFeature.setStyle(drawEndStyle);
        }
        this.selectedFeature = null;
        this.hideMapPopover();
    }
    /**
     * Show the map popover HTML element
     *
     * @memberof DrawPolygonHelper
     */
    showMapPopover() {
        this.mapPopover.style.display = 'block';
    }
    /**
     * Hide the map popover HTML element
     *
     * @memberof DrawPolygonHelper
     */
    hideMapPopover() {
        this.mapPopover.style.display = 'none';
    }
}

class Parcel {
}
class SelectMultipleParcelsHelper {
    constructor(vectorService, olMap, layer, drawLayer, grbParcelLayer, config = null) {
        // Styles
        this.originalStyle = SELECT_PARCEL_COLORS.originalStyle;
        this.style = this.originalStyle;
        this.drawStartStyle = StyleHelper.getDefaultStyle;
        this.vectorService = vectorService;
        this.olMap = olMap;
        this.layer = layer;
        this.drawLayer = drawLayer;
        this.grbParcelLayer = grbParcelLayer;
        this.config = config;
        this.wkt = new WKT();
        this.jstsreader = new jsts.io.WKTReader();
    }
    /**
     * Start parcel selection with point on a layer
     *
     * @memberof SelectMultipleParcelsHelper
     */
    startSelectParcelsWithPointInteraction() {
        this.initDrawLineInteraction('Point');
        this.olMap.addInteraction(this.draw);
    }
    /**
     * Start parcel selection with line on a layer
     *
     * @memberof SelectMultipleParcelsHelper
     */
    startSelectParcelsWithLineInteraction() {
        this.initDrawLineInteraction('LineString');
        this.olMap.addInteraction(this.draw);
    }
    /**
     * Start parcel selection with polygon on a layer
     *
     * @memberof SelectMultipleParcelsHelper
     */
    startSelectParcelsWithPolygonInteraction() {
        this.initDrawLineInteraction('Polygon');
        this.olMap.addInteraction(this.draw);
    }
    initDrawLineInteraction(geometryType) {
        // Clear layer
        this.drawLayer.getSource().clear();
        // Create the draw interaction
        this.draw = new ANBDraw({
            condition: (e) => e.originalEvent.buttons === 1,
            source: this.drawLayer.getSource(),
            type: geometryType,
            style: this.drawStartStyle
        });
        // Subscripte onDrawEnd
        this.draw.onDrawEnd.subscribe((c) => {
            if (!c) {
                return;
            }
            let parcelsToAdd = [];
            let parcelsToDelete = [];
            const drawWkt = this.wkt.writeFeature(c.feature);
            const drawJstsGeometry = this.jstsreader.read(drawWkt);
            const drawExtent = c.feature.getGeometry().getExtent();
            const canDeleteParcelsTasks$ = [];
            const canDeleteParcels = [];
            const canAddParcelsTasks$ = [];
            const canAddParcels = [];
            this.grbParcelLayer.getSource().forEachFeatureInExtent(drawExtent, (feature) => {
                const parcelJstsGeometry = this.jstsreader.read(this.wkt.writeFeature(feature));
                if (drawJstsGeometry.intersects(parcelJstsGeometry)) {
                    const featureCopy = cloneDeep(feature.clone());
                    featureCopy.setId(feature.getId());
                    const geoJsonFeature = new GeoJSON().writeFeature(featureCopy);
                    const geoJson = Object.assign({}, JSON.parse(geoJsonFeature));
                    const capakey = geoJson.properties ? geoJson.properties.CAPAKEY : null;
                    const existingFeature = this.vectorService.getFeatureById(this.layer, featureCopy.getId()?.toString());
                    if (existingFeature) {
                        const existingParcel = {
                            feature: existingFeature,
                            geoJson: geoJson,
                            capakey: capakey,
                        };
                        if (this.config && this.config.canDelete) {
                            canDeleteParcels.push(existingParcel);
                            canDeleteParcelsTasks$.push(this.config.canDelete(existingParcel));
                        }
                        else {
                            parcelsToDelete.push(existingParcel);
                        }
                    }
                    else {
                        featureCopy.setStyle(this.config?.style ?? this.style);
                        const parcel = {
                            feature: featureCopy,
                            geoJson: geoJson,
                            capakey: capakey,
                        };
                        if (this.config && this.config.canAdd) {
                            canAddParcels.push(parcel);
                            canAddParcelsTasks$.push(this.config.canAdd(parcel));
                        }
                        else {
                            parcelsToAdd.push(parcel);
                        }
                    }
                }
            });
            if (canDeleteParcelsTasks$?.length) {
                forkJoin(canDeleteParcelsTasks$).subscribe(results => {
                    parcelsToDelete = canDeleteParcels.filter((_, i) => results[i]);
                    if (parcelsToDelete.length) {
                        this.deleteFeatures(this.layer, parcelsToDelete, this.config?.onDelete);
                    }
                });
            }
            else if (parcelsToDelete.length) {
                this.deleteFeatures(this.layer, parcelsToDelete, this.config?.onDelete);
            }
            if (canAddParcelsTasks$?.length) {
                forkJoin(canAddParcelsTasks$).subscribe(results => {
                    parcelsToAdd = canAddParcels.filter((_, i) => results[i]);
                    if (parcelsToAdd.length) {
                        this.addFeatures(this.layer, parcelsToAdd, this.config?.onAdd);
                    }
                });
            }
            else if (parcelsToAdd.length) {
                this.addFeatures(this.layer, parcelsToAdd, this.config?.onAdd);
            }
            this.olMap.map.render();
            // Reset draw feature
            c.feature?.setStyle(new Style$1());
        });
    }
    /**
     * Stop parcel selection on a layer
     *
     * @memberof SelectMultipleParcelsHelper
     */
    stopSelectParcelsInteraction() {
        this.olMap.removeInteraction(this.draw);
    }
    /**
     * Add a feature on a layer
     *
     * @memberof SelectMultipleParcelsHelper
     */
    addFeatures(layer, parcels, onAdd = null) {
        if (parcels?.length) {
            this.vectorService.addFeatures(layer, parcels.map(p => p.feature));
            if (onAdd) {
                onAdd.next(parcels);
            }
        }
    }
    /**
    *
    * Delete a feature on a layer
    * @memberof SelectMultipleParcelsHelper
    */
    deleteFeatures(layer, parcels, onDelete = null) {
        if (parcels?.length) {
            parcels.forEach(parcel => {
                this.vectorService.deleteFeature(layer, parcel.feature);
            });
            if (onDelete) {
                onDelete.next(parcels);
            }
        }
    }
}

class SelectParcelHelper {
    constructor(grbService, vectorService, olMap, layer, config = null) {
        // Styles
        this.originalStyle = SELECT_PARCEL_COLORS.originalStyle;
        this.style = this.originalStyle;
        this.grbService = grbService;
        this.vectorService = vectorService;
        this.olMap = olMap;
        this.layer = layer;
        this.config = config;
        this.initStyles();
    }
    /**
     * Start parcel selection on a layer
     *
     * @memberof SelectParcelHelper
     */
    startSelectParcelInteraction() {
        this.clickSubscription = this.olMap.map.on('click', (clickResult) => {
            if (!clickResult || !clickResult.coordinate) {
                return;
            }
            this.grbService.getParcelFromPoint([clickResult.coordinate[0], clickResult.coordinate[1]]).subscribe((response) => {
                if (!response) {
                    return;
                }
                const features = response.features;
                if (!features) {
                    return;
                }
                features.forEach((f) => {
                    const id = f.id;
                    const capakey = f.properties ? f.properties.CAPAKEY : null;
                    const feature = new GeoJSON().readFeature(f);
                    feature.setStyle(this.style);
                    const existingFeature = this.vectorService.getFeatureById(this.layer, id);
                    if (existingFeature) {
                        const existingParcel = {
                            feature: existingFeature,
                            geoJson: f,
                            capakey: capakey,
                        };
                        if (this.config && this.config.canDelete) {
                            this.config.canDelete(existingParcel).then((value) => {
                                if (value) {
                                    this.deleteFeature(this.layer, existingParcel, this.config.onDelete);
                                }
                            });
                        }
                        else {
                            this.deleteFeature(this.layer, existingParcel, this.config ? this.config.onDelete : null);
                        }
                    }
                    else {
                        const parcel = {
                            feature: feature,
                            geoJson: f,
                            capakey: capakey,
                        };
                        if (this.config && this.config.canAdd) {
                            this.config.canAdd(parcel).then((value) => {
                                if (value) {
                                    this.addFeature(this.layer, parcel, this.config.onAdd);
                                }
                            });
                        }
                        else {
                            this.addFeature(this.layer, parcel, this.config ? this.config.onAdd : null);
                        }
                    }
                });
            });
        });
    }
    /**
     * Stop parcel selection on a layer
     *
     * @memberof SelectParcelHelper
     */
    stopSelectParcelInteraction() {
        unByKey(this.clickSubscription);
    }
    /**
     * Init styles of the config
     *
     * @memberof DrawPolygonHelper
     */
    initStyles() {
        if (this.config && this.config.style) {
            this.style = this.config.style;
        }
    }
    /**
     * Add a feature on a layer
     *
     * @memberof SelectParcelHelper
     */
    addFeature(layer, parcel, onAdd = null) {
        this.vectorService.addFeature(layer, parcel.feature);
        if (onAdd) {
            onAdd.next(parcel);
        }
    }
    /**
     *
     * Delete a feature on a layer
     * @memberof SelectParcelHelper
     */
    deleteFeature(layer, parcel, onDelete = null) {
        this.vectorService.deleteFeature(layer, parcel.feature);
        if (onDelete) {
            onDelete.next(parcel);
        }
    }
}

class MapInteractionValues {
    constructor() {
        this.isDrawStarted = false;
        this.isDrawCanceled = false;
    }
}
class MapInteractionHelpers {
}
class MapUtilInteractionService {
    constructor(grbService, vectorService, domService) {
        this.grbService = grbService;
        this.vectorService = vectorService;
        this.domService = domService;
        this.mapInteractionHelpers = new Map();
    }
    /**
     * Start parcel selection on a layer
     *
     * @memberof MapUtilInteractionService
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    startSelectParcelInteraction(olMap, layer, config = null) {
        const helper = new SelectParcelHelper(this.grbService, this.vectorService, olMap, layer, config);
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        mapInteractionHelpers.selectParcelHelper = helper;
        if (mapInteractionHelpers.selectParcelHelper) {
            mapInteractionHelpers.selectParcelHelper.startSelectParcelInteraction();
        }
    }
    /**
     * Stop parcel selection on a layer
     *
     * @memberof MapUtilInteractionService
     */
    stopSelectParcelInteraction(olMap) {
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        if (mapInteractionHelpers.selectParcelHelper) {
            mapInteractionHelpers.selectParcelHelper.stopSelectParcelInteraction();
        }
    }
    /**
     * Start multiple parcels selection on a layer
     *
     * @memberof MapUtilInteractionService
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    startSelectMultipleParcelsInteraction(olMap, layer, drawLayer, grbParcelLayer, selectionType, config = null) {
        const helper = new SelectMultipleParcelsHelper(this.vectorService, olMap, layer, drawLayer, grbParcelLayer, config);
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        mapInteractionHelpers.selectMultipleParcelsHelper = helper;
        if (mapInteractionHelpers.selectMultipleParcelsHelper) {
            switch (selectionType) {
                case ParcelSelectionTypeEnum.POINT: {
                    mapInteractionHelpers.selectMultipleParcelsHelper.startSelectParcelsWithPointInteraction();
                    break;
                }
                case ParcelSelectionTypeEnum.LINE: {
                    mapInteractionHelpers.selectMultipleParcelsHelper.startSelectParcelsWithLineInteraction();
                    break;
                }
                case ParcelSelectionTypeEnum.POLYGON: {
                    mapInteractionHelpers.selectMultipleParcelsHelper.startSelectParcelsWithPolygonInteraction();
                    break;
                }
            }
        }
    }
    /**
    * Stop multiple parcels selection on a layer
    *
    * @memberof MapUtilInteractionService
    */
    stopSelectMultipleParcelsInteraction(olMap) {
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        if (mapInteractionHelpers.selectMultipleParcelsHelper) {
            mapInteractionHelpers.selectMultipleParcelsHelper.stopSelectParcelsInteraction();
        }
    }
    /**
     * Start draw of a polygon on a layer
     *
     * @memberof MapUtilInteractionService
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    startDrawPolygonInteraction(olMap, layer, config = null) {
        const helper = new DrawPolygonHelper(this.vectorService, this.domService, olMap, layer, config);
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        mapInteractionHelpers.drawPolygonHelper = helper;
        if (mapInteractionHelpers.drawPolygonHelper) {
            mapInteractionHelpers.drawPolygonHelper.startDrawPolygonInteraction();
        }
    }
    /**
     * Stop draw of a polygon on a layer
     * @memberof MapUtilInteractionService
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    stopDrawPolygonInteraction(olMap, config = null) {
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        if (mapInteractionHelpers.drawPolygonHelper) {
            mapInteractionHelpers.drawPolygonHelper.stopDrawPolygonInteraction();
        }
    }
    /**
     * Starts clip interaction
     * @param olMap: The current map instance
     * @param polygonLayer : The layer with the existing polygons
     * @param [config]
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    startClipInteraction(olMap, polygonLayer, config = null) {
        const helper = new ClipPolygonHelper(this.vectorService, this.domService, olMap, polygonLayer, config);
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        mapInteractionHelpers.clipPolygonHelper = helper;
        if (mapInteractionHelpers.clipPolygonHelper) {
            mapInteractionHelpers.clipPolygonHelper.startClipPolygonInteraction();
        }
    }
    /**
     * Stop clip of a polygon on a layer
     * @memberof MapUtilInteractionService
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    stopClipInteraction(olMap, config = null) {
        const mapInteractionHelpers = this.getMapInteractionHelpers(olMap.mapId);
        if (mapInteractionHelpers.clipPolygonHelper) {
            mapInteractionHelpers.clipPolygonHelper.stopClipPolygonInteraction();
        }
    }
    getMapInteractionHelpers(mapId) {
        if (!this.mapInteractionHelpers.has(mapId)) {
            this.mapInteractionHelpers.set(mapId, new MapInteractionHelpers());
        }
        return this.mapInteractionHelpers.get(mapId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilInteractionService, deps: [{ token: i1$1.GrbWfsService }, { token: i2.VectorService }, { token: DomService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilInteractionService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilInteractionService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.GrbWfsService }, { type: i2.VectorService }, { type: DomService }]; } });

class MapUtilLayerService {
    constructor(httpClient, vectorService, zoomService, configuratieService) {
        this.httpClient = httpClient;
        this.vectorService = vectorService;
        this.zoomService = zoomService;
        this.configuratieService = configuratieService;
        this.grbAdpGrensFeatureSource = new VectorSource({
            format: new GeoJSON(),
            loader: (extent, resolution, projection) => {
                const url = `${this.configuratieService.getValue('/appl/configuratieservice/geo-url/GRB/wfs')}?service=WFS&version=1.1.0&Request=GetFeature&typename=GRB:ADP&outputFormat=application/json&srsname=EPSG:31370&bbox=${extent.join(',')}`;
                this.httpClient
                    .get(url)
                    .toPromise()
                    .then((next) => {
                    const format = this.grbAdpGrensFeatureSource.getFormat();
                    const features = format?.readFeatures(next);
                    features.forEach((f) => f.setStyle(new Style({ stroke: new Stroke({ color: [255, 170, 0, 0.3] }), fill: new Fill({ color: [255, 170, 0, 0] }) })));
                    this.grbAdpGrensFeatureSource.addFeatures(features);
                });
            },
            strategy: bbox,
        });
    }
    getUrlForMapType(type) {
        switch (type) {
            case GrbTypeEnum.grb_bsk:
            case GrbTypeEnum.grb_bsk_grijs:
                return this.configuratieService.getValue('/appl/configuratieservice/geo-url/GRB/wmts/capabilities/xml');
            case GrbTypeEnum.ortho:
                return this.configuratieService.getValue('/appl/configuratieservice/geo-url/OMWRGBMRVL/wmts/capabilities/xml');
            case GrbTypeEnum.ortho_klein_zomer_1979_1990:
                return this.configuratieService.getValue('/appl/configuratieservice/geo-url/OKZ/wmts/capabilities/xml');
            case GrbTypeEnum.ortho_middel_winter_2000_2003:
            case GrbTypeEnum.ortho_middel_winter_2005_2007:
            case GrbTypeEnum.ortho_middel_winter_2008_2011:
            case GrbTypeEnum.ortho_middel_winter_2015:
                return this.configuratieService.getValue('/appl/configuratieservice/geo-url/OMW/wmts/capabilities/xml');
            case GrbTypeEnum.ortho_middel_zomer_2009:
            case GrbTypeEnum.ortho_middel_zomer_2015:
                return this.configuratieService.getValue('/appl/configuratieservice/geo-url/OMZ/wmts/capabilities/xml');
            default:
                console.error('Unable to determine maptype: ' + type);
                return '';
        }
    }
    /**
     * Returns a GRB layer based on WMTS service. Default layer is grb_bsk_grijs
     *
     * @returns Observable<ANBLayer>
     * @memberof MapUtilLayerService
     */
    getGrbLayer(type = GrbTypeEnum.grb_bsk_grijs) {
        const result = new Observable((o) => {
            const url = this.getUrlForMapType(type);
            this.httpClient
                .get(url, {
                responseType: 'text',
            })
                .subscribe((response) => {
                const parser = new WMTSCapabilities();
                const parseResult = parser.read(response);
                const options = optionsFromCapabilities(parseResult, {
                    layer: type,
                    matrixSet: 'BPL72VL',
                });
                const baseLayer = new ANBLayer(`grb ${type}`, new TileLayer({
                    source: new WMTS(options),
                    zIndex: -1,
                    extent: [20072.4024655901885126, 152712.4920640401542187, 259615.8769516685279086, 247185.8252844093367457], // This is necessary because otherwise it would request tiles that are outside the range.
                }));
                o.next(baseLayer);
            });
        });
        return result;
    }
    /**
     * Returns the Orthografische (luchtfoto) layer
     *
     * @returns ANBLayer
     * @memberof MapUtilLayerService
     */
    getOrthoLayer(visible = true) {
        return new ANBLayer('Orthografische kaart', new TileLayer({
            visible: visible,
            source: new TileWMS({
                params: {
                    LAYERS: 'Ortho',
                    CRS: 'EPSG:31370',
                },
                url: `${this.configuratieService.getValue('/appl/configuratieservice/geo-url/OMWRGBMRVL/wms')}?`,
            }),
        }));
    }
    /**
     * Return the Administratief perceel grens layer
     *
     * @returns ANBLayer
     * @memberof MapUtilLayerService
     */
    getAdministratiefPerceelGrensLayer() {
        return new ANBLayer('Administratief perceel grens', new TileLayer({
            source: new TileWMS({
                params: {
                    LAYERS: 'GRB_ADP_GRENS',
                    CRS: 'EPSG:31370',
                },
                url: `${this.configuratieService.getValue('/appl/configuratieservice/geo-url/GRB/wms')}?`,
            }),
        }));
    }
    /**
     * Returns the Administratief perceel grens features layer
     * @returns administratief perceel grens features layer
     */
    getAdministratiefPerceelGrensFeaturesLayer() {
        return new ANBLayer('Administratief perceel grens features', new VectorLayer({
            zIndex: 1000,
            source: this.grbAdpGrensFeatureSource,
            visible: true,
            maxResolution: 3,
        }));
    }
    /**
     * Set parcels on a layer
     *
     * @memberof MapUtilLayerService
     */
    setParcels(olMap, layer, parcels, zoom = true, customStyle = null) {
        let style = SELECT_PARCEL_COLORS.originalStyle;
        if (customStyle) {
            style = customStyle;
        }
        this.setFeaturesOnLayer(olMap, layer, parcels, style, zoom);
    }
    /**
     * Set polygons on a layer
     *
     * @memberof MapUtilLayerService
     */
    setPolygons(olMap, layer, parcels, zoom = true, customStyle = null) {
        let style = DRAW_POLYGON_COLORS.originalDrawEndStyle;
        if (customStyle) {
            style = customStyle;
        }
        this.setFeaturesOnLayer(olMap, layer, parcels, style, zoom);
    }
    setFeaturesOnLayer(olMap, layer, parcels, style, zoom = true) {
        if (parcels) {
            parcels.forEach((f) => {
                const feature = new GeoJSON().readFeature(f);
                feature.setStyle(style);
                this.vectorService.addFeature(layer, feature);
            });
            if (zoom) {
                this.zoomService.zoomToFeatures(olMap.map, layer);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilLayerService, deps: [{ token: i1$2.HttpClient }, { token: i2.VectorService }, { token: i2.ZoomService }, { token: i3.AnbNgConfiguratieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilLayerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilLayerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }, { type: i2.VectorService }, { type: i2.ZoomService }, { type: i3.AnbNgConfiguratieService }]; } });

class MapUtilMunicipalityService {
    constructor(httpClient, configuratieService) {
        this.httpClient = httpClient;
        this.configuratieService = configuratieService;
        this.api = 'WFS_VRBG';
        this.api = configuratieService.getValue('/appl/configuratieservice/geo-url/VRBG/wfs');
    }
    /**
     * Returns the municipalities intersecting the polygon
     *
     */
    getMunicipalitiesWfsFromPolygon(polygon) {
        if (polygon.geometry.type !== 'Polygon') {
            throw new Error('GeoJSON is niet van type polygoon');
        }
        const olFeature = new GeoJSON().readFeature(polygon);
        const geometry = olFeature.getGeometry();
        const request = new WFS().writeGetFeature({
            featureNS: 'VRBG',
            featurePrefix: 'VRBG',
            featureTypes: ['VRBG:Refgem'],
            srsName: 'EPSG:31370',
            outputFormat: 'application/json',
            filter: intersects('SHAPE', geometry),
        });
        const ogcFilter = new XMLSerializer().serializeToString(request);
        return this.httpClient.post(this.api, ogcFilter);
    }
    /**
     * Returns the municipalities intersecting the polygon
     *
     */
    getMunicipalitiesFromPolygon(polygon) {
        return this.getMunicipalitiesWfsFromPolygon(polygon).pipe(map((x) => x.features
            ? x.features.map((y) => ({
                name: y.properties.NAAM,
                code: y.properties.NISCODE,
                geoJson: y,
            }))
            : []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilMunicipalityService, deps: [{ token: i1$2.HttpClient }, { token: i3.AnbNgConfiguratieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilMunicipalityService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: MapUtilMunicipalityService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }, { type: i3.AnbNgConfiguratieService }]; } });

const AnbMapsUtilParameterKeys = [
    '/appl/configuratieservice/geo-url/OMWRGBMRVL/wms',
    '/appl/configuratieservice/geo-url/GRB/wfs',
    '/appl/configuratieservice/geo-url/GRB/wms',
    '/appl/configuratieservice/geo-url/GRB/wmts/capabilities/xml',
    '/appl/configuratieservice/geo-url/OMWRGBMRVL/wmts/capabilities/xml',
    '/appl/configuratieservice/geo-url/OKZ/wmts/capabilities/xml',
    '/appl/configuratieservice/geo-url/OMW/wmts/capabilities/xml',
    '/appl/configuratieservice/geo-url/OMZ/wmts/capabilities/xml',
    '/appl/configuratieservice/geo-url/VRBG/wfs',
];

/*
 * Public API Surface of anb-ng-maps-util
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnbMapsUtilParameterKeys, ClipInteractionConfiguration, ClipInteractionResult, DRAW_POLYGON_COLORS, DomService, GrbTypeEnum, MapInteractionHelpers, MapInteractionValues, MapPopoverComponent, MapUtilInteractionService, MapUtilLayerService, MapUtilModule, MapUtilMunicipalityService, MultipleParcelInteractionConfiguration, Municipality, Parcel$1 as Parcel, ParcelInteractionConfiguration, ParcelSelectionTypeEnum, Polygon, PolygonInteractionConfiguration, SELECT_PARCEL_COLORS };
